// configureZod must run before any import that defines a zod schema; the sort
// rule's autofix would move it below them.
// eslint-disable-next-line simple-import-sort/imports
import './configureZod';

import React from 'react';
import ReactDOM from 'react-dom/client';

import { AdminApp } from './AdminApp';

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <AdminApp />
  </React.StrictMode>,
);
